var React = require('react');

function Duration (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 0.666504H6V1.99984H10V0.666504ZM7.33333 9.33317H8.66667V5.33317H7.33333V9.33317ZM12.6867 4.9265L13.6333 3.97984C13.3467 3.63984 13.0333 3.31984 12.6933 3.03984L11.7467 3.9865C10.7133 3.15984 9.41333 2.6665 8 2.6665C4.68667 2.6665 2 5.35317 2 8.6665C2 11.9798 4.68 14.6665 8 14.6665C11.32 14.6665 14 11.9798 14 8.6665C14 7.25317 13.5067 5.95317 12.6867 4.9265ZM8 13.3332C5.42 13.3332 3.33333 11.2465 3.33333 8.6665C3.33333 6.0865 5.42 3.99984 8 3.99984C10.58 3.99984 12.6667 6.0865 12.6667 8.6665C12.6667 11.2465 10.58 13.3332 8 13.3332Z","fill":"currentColor"}));
}

Duration.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Duration;

Duration.default = Duration;
